<template>
	<div class="div-editable" contenteditable   @focus="focusFunc" ref="editDiv" @keyup="getCursor" @blur="blurFunc"></div>
</template>
<script>

export default {
	props:['otherMsg'],
	data(){
		return {
			editor:'',
			cursorPosition:0,//光标位置值
		}
	},
	watch:{
		'otherMsg':{
			handler(val){
				//const text = this.editor.innerHTML
				//this.editor.innerHTML = text.slice(0, this.cursorPosition) + val + text.slice(this.cursorPosition, text.length);
				this.insertContent(val)
				// this.setCursorPosition(this.editor, this.cursorPosition);
				// this.cursorPosition = this.getCursorPosition(this.editor) 
			},
			immediate:true,
			deep:true
		}
	},
	methods:{
		focusFunc() {
			this.$refs.editDiv.focus();
			this.saveRange();
			
		},
		blurFunc(){
			this.saveRange();
			// this.$emit('customerInputEvent', this.$el.innerHTML);
			this.$emit('customerInputEvent',this.formatHtml(this.$el.innerHTML));
		},
		formatHtml(html){
			if (html == null) {
				return ''
			}
			return html
				.replace(/<div><br><\/div>/g, '<br/>')
				.replace(/(\r\n|\r|\n)/g, '')
		},
		saveRange() {
			var selection = window.getSelection ? window.getSelection() : document.selection;
			if (!selection.rangeCount) return;
			var range = selection.createRange ? selection.createRange() : selection.getRangeAt(0);
			window._range = range;
		},
		getCursor() {
			this.cursorPosition = this.getCursorPosition(this.editor);
		},
		getCursorPosition(element) {
			let caretOffset = 0
			const doc = element.ownerDocument || element.document
			const win = doc.defaultView || doc.parentWindow
			const sel = win.getSelection();
			if (sel.rangeCount > 0) {
				const range = win.getSelection().getRangeAt(0)
				const preCaretRange = range.cloneRange()
				preCaretRange.selectNodeContents(element)
				preCaretRange.setEnd(range.endContainer, range.endOffset)
				caretOffset = preCaretRange.toString().length
			}
			return caretOffset
		},
		setCursorPosition (element, cursorPosition) {
				const range = document.createRange();
				range.setStart(element.firstChild, cursorPosition)
				range.setEnd(element.firstChild, cursorPosition)
				const sel = window.getSelection()
				sel.removeAllRanges()
				sel.addRange(range)
		},
		insertContent(str) {
			this.$nextTick(() => {
				let selection, range = window._range;
				if (!window.getSelection) {
					range.pasteHTML(str);
					range.collapse(false);
					range.select();
				} else {
					selection = window.getSelection ? window.getSelection() : document.selection;
					range.collapse(false);
					let hasR = range.createContextualFragment(str);
					let hasR_lastChild = hasR.lastChild;
					while (hasR_lastChild && hasR_lastChild.nodeName.toLowerCase() == "br" && hasR_lastChild.previousSibling && hasR_lastChild.previousSibling.nodeName.toLowerCase() == "br") {
						let e = hasR_lastChild;
						hasR_lastChild = hasR_lastChild.previousSibling;
						hasR.removeChild(e);
					}
					range.insertNode(hasR);
					if (hasR_lastChild) {
						range.setEndAfter(hasR_lastChild);
						range.setStartAfter(hasR_lastChild);
					}
					selection.removeAllRanges();
					selection.addRange(range);
				}  
			})
		},
		keepLastIndex(obj){
			obj.focus(); 
			var range = window.getSelection(); 
			range.selectAllChildren(obj); 
			range.collapseToEnd(); 
		}
	},
	mounted(){
		this.editor = this.$refs['editDiv'];
		this.editor.focus()
	}
}
</script>
<style scoped lang="scss">
 .div-editable {
	width: 100%;
	height:100%;
	overflow-y: auto;
	word-break: break-all;
	outline: none;
	user-select: text;
	white-space: pre-wrap;
	text-align: left;
	border: 1px solid #D8D8D8;
	border-radius: 4px;
	padding: 10px 20px;
	color: #3C4353;
	font-size: 14px;
	line-height: 20px;
	&[contenteditable='true'] {
		user-modify: read-write-plaintext-only;
	}
	
	&[contenteditable='true']:empty:before {
		content: attr(placeholder);
		display: block;
		color: red;
	}
 }
</style>